import React from 'react'
import { getRootElement } from './index.common'
import lib from '../package.json'
import { appConfig } from './config'
import { createIDBPersister, trimLocalStorage } from 'utils/storage'
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import PublicSlotListingProvider from 'containers/PublicSlotListingProvider'
import { CookieProvider } from 'contexts/cookies'
import { WindowSizeProvider } from 'contexts/window'
import { LocationProvider } from 'contexts/location'

(() => {
  window.BILDIT = {
    ...window.BILDIT,
    version: lib.version,
    init: () => {
      if (!window.indexedDB) {
        trimLocalStorage()
      }
    },
    info: {
      version: lib.version,
      scriptInstalled: true,
      appId: appConfig.webAppId
    },
    persistent: false,
    categoryValidations: {}
  }

  window.BILDIT.init?.()
})()

const CACHE_TIME = 60 * 60 * 1000 // 1 hour
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: CACHE_TIME,
      staleTime: CACHE_TIME
    }
  }
})

const persister = window.indexedDB
  ? createIDBPersister()
  : createSyncStoragePersister({
    storage: window.localStorage
  })

const PublicWrapper = () => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}
    >
      <CookieProvider cookies={appConfig.cookies}>
        <LocationProvider>
          <WindowSizeProvider>
            <PublicSlotListingProvider />
          </WindowSizeProvider>
        </LocationProvider>
      </CookieProvider>
    </PersistQueryClientProvider>
  );
}

const toolBar = getRootElement()
if (toolBar) {
  toolBar.render(
    <PublicWrapper />
  )
}
